import { StoredServiceAction } from "../models/stored-service-action";
import { IStoredMapper } from "../../../storage/mappers/stored-mapper";
import { ServiceActionDto } from "../../models/dtos/service-action.dto";

/**
 * Mapping class that maps between ServiceAction dto and database StoredServiceAction.
 */
export class ServiceActionMapper implements IStoredMapper<ServiceActionDto, StoredServiceAction> {
	/**
	 * Maps a ServiceActionDto to a StoredServiceAction.
	 * @param serviceAction The service action data to convert.
	 * @returns A StoredServiceAction object.
	 */
	public ToStored(serviceAction: ServiceActionDto): StoredServiceAction {
		return {
			ActionType: serviceAction.ActionType,
			Required: serviceAction.Required,
			CompletedDate: serviceAction.CompletedDate
		};
	}

	/**
	 * Maps a StoredServiceAction to a ServiceActionDto.
	 * @param storedServiceAction The stored service action data to convert.
	 * @returns A ServiceAction object.
	 */
	public FromStored(storedServiceAction: StoredServiceAction): ServiceActionDto {
		return {
			ActionType: storedServiceAction.ActionType,
			Required: storedServiceAction.Required,
			CompletedDate: storedServiceAction.CompletedDate
		};
	}
}